module.exports = global["tippy"] = require("-!/home/runner/work/consumer/consumer/node_modules/babel-loader/lib/index.js??ref--4!./tippy.min.js");